export default "__VITE_ASSET__g6tYw6Y4__"